<div class="flyout-scores-component">
  <div class="flyout-data-group">
    <mat-expansion-panel [expanded]="!expandedTab || expandedTab === 'scores'" class="mat-elevation-z0">
      <mat-expansion-panel-header [collapsedHeight]="'48px'" [expandedHeight]="'48px'">
        <mat-icon>looks_one</mat-icon>
        <span>{{ "flyout.scores" | translate }}</span>
      </mat-expansion-panel-header>

      @for (score of (flyoutService.personDetailsBS | async).scores; track score) {
        <div class="expansion-panel-row values">
          <div class="value name">
            {{ score.type }}
          </div>
          <div class="value date">
            <span>{{ score.latestTime | date: "yyyy-MM-dd HH:mm" }}</span>
          </div>
          <div class="value number">{{ score.latestScore }}</div>
        </div>
      }
    </mat-expansion-panel>
  </div>
</div>
